/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: true,
  /* Reemplazar por ruta de controlador */
  // BASE_API_URL: 'http://localhost:3257/apptui_unap/',
  // BASE_API_URL: 'https://obbtuiuvexterno.uv.cl/apptui_unap/',
  BASE_API_URL: "https://apptui-node01.unap.cl/apptui_unap/",
  PAGES: {
    home: { url: "home" },
    asignaturas: { url: "asignaturas" },
    notas: { url: "notas" },
  },
};
